export const environment = {
  production: false,
  urlBase: 'https://easyboard.client.lx.dev.eng.com.ar',
  providersApiUrl: 'https://easyboard.providers.lx.dev.eng.com.ar',
  backendApiUrl: 'https://easyboard.api.lx.dev.eng.com.ar',
  sellTicketsUrl: 'https://easyboard.zonapasajes.com.ar/',
  returnUrl: 'https://easyboard.client.lx.dev.eng.com.ar/checkout',
  httpTimeout: 100000,
  firebase: {
    apiKey: 'AIzaSyArfgIanqG5_ftKGcizK6svHZhQ2ajQFNQ',
    authDomain: 'easyboard-dev-e8030.firebaseapp.com',
    projectId: 'easyboard-dev-e8030',
    storageBucket: 'easyboard-dev-e8030.firebasestorage.app',
    messagingSenderId: '314775265625',
    appId: '1:314775265625:web:8646da97acb38f34f5ac48',
    measurementId: 'G-9VJ1MF7CDE',
  },
  googleAnalytics: {
    measurementId: "G-9VJ1MF7CDE"
  },
  name: 'EasyBoard',
  recaptchaSiteKey: '6LeEv64rAAAAAGj-Ssvq-DDlAEf-Poje20weuUdo'
};